import { render } from "./PostBasic.vue?vue&type=template&id=a8084138&scoped=true"
import script from "./PostBasic.vue?vue&type=script&lang=js"
export * from "./PostBasic.vue?vue&type=script&lang=js"

import "./PostBasic.vue?vue&type=style&index=0&id=a8084138&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8084138"]])

export default __exports__